export interface LinkList {
  title: string;
  items: LinkListItem[];
}

export interface LinkListItem {
  cx_event_key?: string;
  label: string;
  icon?: string;
  href?: string;
  route?: string;
  target?: string;
}

export interface LinkListArgs {
  dataList: LinkListItem[];
  clicked?: () => void;
  customMethod?: (event: unknown) => void;
}
